import { render, staticRenderFns } from "./FeedbackPopup.vue?vue&type=template&id=97bf5abc&scoped=true&"
import script from "./FeedbackPopup.vue?vue&type=script&lang=js&"
export * from "./FeedbackPopup.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPopup.vue?vue&type=style&index=0&id=97bf5abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bf5abc",
  null
  
)

export default component.exports